import request from '@/libs/request'

// 广告列表
export function advertList (data) {
  return request({
    url: `advert/list`,
    method: 'get',
    params: data
  })
}

// 上下架
export function changeStatus (data) {
  return request({
    url: `advert/changeStatus`,
    method: 'post',
    data: data
  })
}

// 添加广告
export function addAdv (data) {
  return request({
    url: `advert/edit`,
    method: 'post',
    data: data
  })
}
// 删除幻灯
export function delAdv (id) {
  let data = { advert_id: id}
  return request({
    url: `advert/delete`,
    method: 'post',
    data: data
  })
}
// 幻灯列表
export function advertHdList (data) {
  return request({
    url: `advert/listHd`,
    method: 'get',
    params: data
  })
}
export function changeSort (params) {
  return request({
    url: `advert/changeSort`,
    method: 'get',
    params
  })
}
// 广告详情
export function advertApi (data) {
  return request({
    url: `advert/info`,
    method: 'get',
    params: data
  })
}

// 选择商品
export function selectGoods (data) {
  return request({
    url: `advert/selectGoods`,
    method: 'get',
    params: data
  })
}

// 轮播组列表
export function advGroupList (data) {
  return request({
    url: `advert/groupList`,
    method: 'get',
    params: data
  })
}

// 绘本
export function bookInfo () {
  return request({
    url: `advert/bookInfo`,
    method: 'get'
  })
}
// 导读
export function bookVideo () {
  return request({
    url: `advert/bookVideo`,
    method: 'get'
  })
}
// 活动
export function activityInfo () {
  return request({
    url: `advert/activityInfo`,
    method: 'get'
  })
}
// 活动
export function articleInfo () {
  return request({
    url: `advert/articleInfo`,
    method: 'get'
  })
}



export function advertList2 (data) {
  return request({
    url: `advert/list2`,
    method: 'get',
    params: data
  })
}
